import AsyncStorage from '@react-native-async-storage/async-storage';

const PHOTO_SEARCH_RESUME_KEY = '@dengfeng/photo-search/resume-v1';
const FORBIDDEN_KEYS = new Set(['file', 'accessToken', 'temporaryPassword', 'password', 'token']);

export const serializePhotoSearchResumeState = (state: unknown): string =>
  JSON.stringify(state, (key, value) => {
    if (key === 'file') {
      return null;
    }
    if (FORBIDDEN_KEYS.has(key)) {
      return undefined;
    }
    return value;
  });

export const parsePhotoSearchResumeState = <T>(raw: string | null): T | null => {
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    if (!parsed || typeof parsed !== 'object' || typeof parsed.status !== 'string') {
      return null;
    }
    return parsed as T;
  } catch {
    return null;
  }
};

export const loadPhotoSearchResumeState = async <T>(): Promise<T | null> =>
  parsePhotoSearchResumeState<T>(await AsyncStorage.getItem(PHOTO_SEARCH_RESUME_KEY));

export const savePhotoSearchResumeState = async (state: unknown): Promise<void> => {
  await AsyncStorage.setItem(PHOTO_SEARCH_RESUME_KEY, serializePhotoSearchResumeState(state));
};

export const clearPhotoSearchResumeState = async (): Promise<void> => {
  await AsyncStorage.removeItem(PHOTO_SEARCH_RESUME_KEY);
};
